//src/components/templates/ProductCategoryTemplate.js
import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Button from '../ui/Button';
import ProductCard from '../ui/ProductCard';
import { Link } from 'react-router-dom';
import image12 from'../../assets/images/homepage/bottom.jpg';

const ProductCategoryTemplate = ({ 
  title, 
  description, 
  heroImage,
  products = [],
  relatedCategories = []
}) => {
  return (
    <div className="min-h-screen bg-cream">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-brown-light/10 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            {/* Text Content */}
            <div className="flex-1 max-w-2xl">
              <div className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
                OUR PRODUCT RANGE
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-brown mb-6 leading-tight">
                {title}
              </h1>
              <p className="text-brown-light text-lg mb-8 leading-relaxed">
                {description}
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/contact"><Button variant="primary" icon="→">Contact Us</Button></Link>
                <Link to="/products#products-category"><Button variant="secondary" icon="→">View Catalog</Button></Link>
              </div>
            </div>

            {/* Hero Image */}
            <div className="flex-1 max-w-xl">
              <div className="relative">
                <div className="absolute -top-4 -left-4 w-32 h-32 bg-primary/10 rounded-full blur-2xl"></div>
                <div className="absolute -bottom-4 -right-4 w-40 h-40 bg-primary-light/10 rounded-full blur-2xl"></div>
                <img 
                  src={heroImage || "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=600&h=400&fit=crop"} 
                  alt={title}
                  className="relative rounded-3xl shadow-xl w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 bg-cream">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {products.map((product, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 mb-24`}
            >
              {/* Product Image */}
              <div className="flex-1 max-w-xl">
                <div className="relative">
                  <img 
                    src={product.image || "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=600&h=400&fit=crop"} 
                    alt={product.name}
                    className="rounded-3xl shadow-lg w-full h-80 object-cover"
                  />
                </div>
              </div>

              {/* Product Details */}
              <div className="flex-1 max-w-xl">
                <div className="text-sm font-semibold text-primary mb-2 uppercase tracking-wide">
                  {product.category || "PRODUCT"}
                </div>
                <h3 className="text-3xl font-bold text-brown mb-4">
                  {product.name}
                </h3>
                <p className="text-brown-light mb-6 leading-relaxed">
                  {product.description}
                </p>

                {/* Features List */}
                {product.features && product.features.length > 0 && (
                  <ul className="space-y-3 mb-6">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                        </svg>
                        <span className="text-brown-light">{feature}</span>
                      </li>
                    ))}
                  </ul>
                )}

                <div className="flex flex-wrap gap-4">
                  <Link to="/contact"><Button variant="primary" icon="→">Contact Us</Button></Link>
                <Link to="/products#products-category"><Button variant="secondary" icon="→">View Catalog</Button></Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Related Categories Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="text-sm font-semibold text-primary mb-3 uppercase tracking-wide">
              PRODUCT CATEGORIES
            </div>
            <h2 className="text-3xl font-bold text-brown mb-4">
              Explore Our Product Portfolio
            </h2>
            <p className="text-brown-light max-w-3xl mx-auto">
              An overview of our specialized categories—crafted to meet every baker's need with performance and precision.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {relatedCategories.map((category, index) => (
              <ProductCard 
                key={index}
                title={category.title}
                description={category.description}
                itemCount={category.itemCount}
                image={category.image}
                link={category.link}
                category="PRODUCT CATEGORY"
              />
            ))}
          </div>
        </div>
      </section>

     {/* CTA Section */}
<section className="py-16 bg-cream">
  <div className="max-w-5xl mx-auto px-6 lg:px-8">
    <div className="bg-white rounded-3xl shadow-lg p-8 lg:p-12 flex flex-col lg:flex-row items-center gap-8">

      {/* Image */}
      <div className="flex-1 max-w-md">
        <div className="rounded-2xl overflow-hidden h-64 w-full">
          <img 
            src={image12}   // <-- your .jpg image here
            alt="CTA"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* CTA Content */}
      <div className="flex-1">
        <h3 className="text-3xl font-bold text-brown mb-4">
          Need The Right Ingredient?<br/>Let's Talk!
        </h3>
        <p className="text-brown-light mb-6">
          Whether you're scaling production or testing a new recipe, our experts are ready to guide you. 
          Get free samples, technical insights, or a complete product catalog tailored to your needs.
        </p>
        <div className="flex flex-wrap gap-4">
          <Link to="/contact"><Button variant="primary" icon="→">Contact Us</Button></Link>
          <Link to="/contact#inquiry-section"><Button variant="secondary" icon="→">Enquiry Form</Button></Link>
        </div>
      </div>

    </div>
  </div>
</section>


      <Footer />
    </div>
  );
};

export default ProductCategoryTemplate;

// Usage Example for Bread Improvers page:
// <ProductCategoryTemplate 
//   title="Bread Improvers & Dough Conditioners"
//   description="Boost volume, improve texture, extend shelf-life, standardize batches—with zero guesswork."
//   heroImage="..."
//   products={[
//     {
//       name: "High-Quality Breads",
//       category: "BREAD IMPROVERS",
//       description: "Our bread improvers help you achieve...",
//       features: ["Enhanced volume", "Improved texture", "Extended shelf life"],
//       image: "..."
//     }
//   ]}
//   relatedCategories={[...]}
// />